class TurnierModelInitialXY {
    static startwerte() {
        return{ebene: 1, x: 10, y: 80, interval:80, maxX:1330};
    }
}

export default TurnierModelInitialXY;
